module.exports = __webpack_public_path__ + "static/media/archive-dropdown-icon.a6770b57.svg";